<template>
  <div>
    <div
      class="head_table padding d-flex align-items-center justify-content-between border rounded-top border-bottom-0 flex-wrap"
      style="border-top-left-radius: 10px !important; border-top-right-radius: 10px !important;"
    >
      <div class="p-2 header-title-block">
        <h2 class="main_title m-0 mb-2">
          {{ title }} <span class="total">{{ total }} {{ subTitle }}</span>
        </h2>
        <p class="mb-0 text">
          {{ text }}
        </p>
      </div>

      <div class="d-flex justify-content-end header-actions-block">
        <!-- ✅ Export Button with Loader -->
        <button 
          class="btn_2 mr-3" 
          @click="exportData" 
          v-if="exportFlag"
          :disabled="isExporting"
        >
          <template v-if="!isExporting">
            <i class="nc-icon nc-cloud-download-93 font-weight-bold"></i>
            <span>{{ localization("Export") }}</span>
          </template>
          <template v-else>
            <i class="fa fa-spinner fa-spin"></i>
            <span>{{ localization("Exporting...") }}</span>
          </template>
        </button>

        <AppButton
          @click="ToggleJoinModal"
          :text="joinbuttonText"
          v-if="joinbuttonText"
          class="mr-2 btn btn-light"
        ></AppButton>

        <AppButton
          @click="ToggleInviteModal"
          :joinbtn="true"
          :text="invitebuttonText"
          v-if="invitebuttonText"
          class="mr-2 btn-light"
        ></AppButton>

        <AppButton
          @click="ToggleTaskModal"
          :text="buttonText"
          v-if="buttonText"
          :teamStatus="teamStatus"
        ></AppButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableHeaderSection",
  props: {
    title: { type: String, default: "" },
    subTitle: { type: String, default: "" },
    text: { type: String, default: "" },
    buttonText: { type: String, default: "" },
    exportFlag: { type: Boolean, default: false },
    joinbuttonText: { type: String, default: "" },
    invitebuttonText: { type: String, default: "" },
    total: { type: [String, Number], default: "" },
    teamStatus: { type: Boolean, default: false }
  },
  data() {
    return { isExporting: false };
  },
  methods: {
    async exportData() {
      this.isExporting = true;
      try {
        await new Promise((resolve, reject) => {
          this.$emit("exportData", resolve, reject);
        });
      } catch (e) {
        console.error("Export failed:", e);
      } finally {
        this.isExporting = false;
      }
    },
    ToggleTaskModal() {
      this.$emit("toggleModal");
    },
    ToggleJoinModal() {
      this.$emit("toggleJoinModal");
    },
    ToggleInviteModal() {
      this.$emit("toggleInviteModal");
    },
    localization(text) {
      return text;
    }
  }
};
</script>

<style lang="scss" scoped>
.head_table {
  border-bottom: 1px solid #eaecf0;
  .total {
    background: #f2f4f7;
    border-radius: 16px;
    padding: 4px 10px;
    font-size: 14px;
    color: #344054;
  }
}

.header-title-block {
  flex: 1;
  min-width: 0; // prevent overflow on small screens
}

.header-actions-block {
  flex-shrink: 0;

  @media (max-width: 576px) {
    width: 100%;
    justify-content: flex-end !important;
    padding: 8px 8px 4px;
  }
}

.main_title {
  color: #101828;
  font-weight: 500;
  font-size: 20px;

  @media (max-width: 576px) {
    font-size: 16px;
  }
}

.padding {
  padding: 14px;
}

.text {
  color: #667085;
  font-weight: 400;
  font-size: 16px;

  @media (max-width: 576px) {
    font-size: 14px;
  }
}

.btn_2 {
  border: 1px solid transparent;
  border-radius: 8px;
  color: #6941c6;
  font-size: 16px;
  height: 41px;
  padding: 10px 5px;
  display: flex;
  align-items: center;
  font-weight: 500;
  gap: 10px;
  background: transparent;
  transition: all 0.2s ease;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.fa-spinner {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
